module.exports = __webpack_public_path__ + "img/hest15.27d8dd8c.jpg";